
export function StatisticsWidget() {
    return (
        <div>
            <h2>Stats widget here!</h2>
        </div>
    );
}